import { computed } from "@preact-signals/safe-react";

import { ENVIRONMENT } from "../../utils/runtimeConfig";
import { countryCode$ } from "../org/state";

const ACTIVITY_DEPT_READONLY_COUNTRIES = ["PT", "FR", "SE", "JP", "IN"];

export const isDev =
  ENVIRONMENT.startsWith("dev") ||
  window.location.hostname.includes("localhost");
export const isStage = ENVIRONMENT.startsWith("stage");

export const isProd = !(isDev || isStage);

export const showCC = window.location.search.includes("version=cc");

/** Plan tab hours chart — on by default in Dev/localhost; elsewhere use `?planChart`. */
export const showPlanChart = (
  search: string = window.location.search,
): boolean => {
  return isDev || new URLSearchParams(search).has("planChart");
};

/*
Allows the following Admin features:
* 1. See Metrics tab which shows adoption rate of features.
* 2. Republish transactions in DB, via Publish modal. 
* 3. Bulk upload of activities, via Activity Catalogue.
* 4. Refresh Org Cache in server, need after manual run of OM Job.
* 5. Editing of Activity-Dept relation (see below)
*/
export const showAdminActions = (
  search: string = window.location.search,
): boolean => {
  return new URLSearchParams(search).has("showAdminActions");
};

/*
 * Activity editing is allowed under the following conditions:
 * 1. In Dev and Stage environments, for all countries.
 * 2. In Prod environment, for countries that are not in the ACTIVITY_DEPT_READONLY_COUNTRIES list.
 * 3. In Prod environment, for all countries if the URL contains the query parameter "showAdminActions".
 */
export const enableActivityDept = computed(() => {
  if (!isProd) return true;
  const code = countryCode$.value ?? "";
  return showAdminActions() || !ACTIVITY_DEPT_READONLY_COUNTRIES.includes(code);
});
